import {
  ADD_MATERIAL_SUPPLY,
  DELETE_MATERIAL_SUPPLY,
  LOAD_CHARACTER_DROPDOWNS_FULFILLED,
  LOAD_CHARACTER_DROPDOWNS_PENDING,
  LOAD_CHARACTER_DROPDOWNS_REJECTED,
  RESET_ADD_POST_FORM,
  SET_ADD_POST_FORM,
  SUBMIT_ADD_POST_FORM_FULFILLED,
  SUBMIT_ADD_POST_FORM_PENDING,
  SUBMIT_ADD_POST_FORM_REJECTED,
  UPDATE_ADD_MATERIAL_MENU_IS_OPEN,
  UPDATE_MATERIAL_FILE_NAMES,
  UPDATE_MATERIAL_SUPPLY,
  UPDATE_PHOTO_NAMES,
} from '../../actions';

import {fromJS, List, Map} from 'immutable';

import {
  LOAD_GRADES_FULFILLED,
  LOAD_GRADES_PENDING,
  LOAD_GRADES_REJECTED,
  LOAD_LESSON_PLAN_TYPES_FULFILLED,
  LOAD_LESSON_PLAN_TYPES_PENDING,
  LOAD_LESSON_PLAN_TYPES_REJECTED,
  LOAD_SUBJECTS_FULFILLED,
  LOAD_SUBJECTS_PENDING,
  LOAD_SUBJECTS_REJECTED,
} from '../../../shared/actions';

const initialState = new Map({
  addMaterialIsOpen: false,
  loading: false,
  characterDropdowns: new List(),
  grades: new List(),
  lessonPlanTypes: new List(),
  submitting: false,
  subjects: new List(),
  model: new Map({
    title: '',
    characterId: '',
    featuredImageName: '',
    materials: new Map({
      fileNames: new List(),
      supplies: new List(),
    }),
    photoNames: new List(),
    gradeIds: new List(),
    lessonPlanType: '',
    schoolwide: false,
    homeCommunity: false,
    content: '',
  }),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_LESSON_PLAN_TYPES_PENDING:
    case LOAD_GRADES_PENDING:
    case LOAD_CHARACTER_DROPDOWNS_PENDING:
    case LOAD_SUBJECTS_PENDING:
      return state.set('loading', true);

    case LOAD_LESSON_PLAN_TYPES_REJECTED:
    case LOAD_GRADES_REJECTED:
    case LOAD_CHARACTER_DROPDOWNS_REJECTED:
    case LOAD_SUBJECTS_REJECTED:
      return state.set('loading', false);

    case LOAD_CHARACTER_DROPDOWNS_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('characterDropdowns', fromJS(action.payload.data))
      );

    case LOAD_GRADES_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('grades', fromJS(action.payload.data))
      );

    case LOAD_LESSON_PLAN_TYPES_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('lessonPlanTypes', fromJS(action.payload.data))
      );

    case LOAD_SUBJECTS_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('subjects', fromJS(action.payload.data))
      );

    case RESET_ADD_POST_FORM:
      return initialState;

    case SET_ADD_POST_FORM:
      return state.setIn(['model', action.payload.name], fromJS(action.payload.value));

    case UPDATE_ADD_MATERIAL_MENU_IS_OPEN:
      return state.set('addMaterialIsOpen', action.payload);

    case UPDATE_MATERIAL_FILE_NAMES:
      return state.setIn(['model', 'materials', 'fileNames'], action.payload);

    case ADD_MATERIAL_SUPPLY:
      return state.setIn(['model', 'materials', 'supplies'], state.getIn(['model', 'materials', 'supplies']).push(''));

    case UPDATE_MATERIAL_SUPPLY:
      return state.setIn(['model', 'materials', 'supplies'],
        state.getIn(['model', 'materials', 'supplies'])
          .update(action.payload.index, () => action.payload.text)
      );

    case DELETE_MATERIAL_SUPPLY:
      return state.setIn(['model', 'materials', 'supplies'],
        state.getIn(['model', 'materials', 'supplies'])
          .delete(action.payload)
      );

    case UPDATE_PHOTO_NAMES:
      return state.setIn(['model', 'photoNames'], action.payload);

    case SUBMIT_ADD_POST_FORM_PENDING:
      return state.set('submitting', true);

    case SUBMIT_ADD_POST_FORM_FULFILLED:
      return state.set('submitting', false);

    case SUBMIT_ADD_POST_FORM_REJECTED:
      return state.set('submitting', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/reducers/pages/addPostForm.js